module.exports = __webpack_public_path__ + "static/media/武汉军运会场馆-min.ae693830.jpg";